export const reportsData = {
title:"Berichte"
};